import React, { useState, useEffect, useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels
);

const BarChart = ({
  scores = [],
  auditCycle = [],
  maxMarks = [],
  colorCodes = [],
  filteredData = null, 
  isInteractive = true, 
  onBarClick = null,
}) => {
  const chartRef = useRef(null);
  const total = 100;

  const [selectedBarIndex, setSelectedBarIndex] = useState(null);

    const sourceData = (filteredData || auditCycle).map((cycle, index) => {
      const score = scores[index] || 0;
      const maxMark = maxMarks[index] || 0;
      const percentage = maxMark > 0 ? Math.round((score / maxMark) * 100) : 0;
      const backendColorCode = colorCodes[index] || 0;
    const givenColors =
      backendColorCode === 1
        ? "rgb(205, 92, 92)"
        : backendColorCode === 2
        ? "rgb(255, 127, 80)"
        : backendColorCode === 3
        ? "rgb(219, 176, 1)"
        : backendColorCode === 4
        ? "rgb(76, 169, 215)"
        : backendColorCode === 5
        ? "rgb(104, 136, 51)"
        : "#007dc1";
    return {
      label: cycle,
      value: percentage,
      color: givenColors,
    };
  });

  const handleBarClick = (index) => {
    if (isInteractive && onBarClick) {
      onBarClick(index);
    }
    setSelectedBarIndex(index === selectedBarIndex ? null : index);
  };

  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, []);

  return (
    <div>
      <div
        className="chart-container"
        style={{
          height: "18rem",
          width: "97%",
          position: "relative",
          overflow: "hidden",
        }}
      >
         <Bar
          ref={chartRef}
          data={{
            labels: sourceData.map((data) => data.label),
            datasets: [
              {
                label: "Score",
                data: sourceData.map((data) => data.value),
                backgroundColor: sourceData.map((data) =>
                  data.color === "#888" ? "#B0E3FF" : data.color
                ),
                hoverBackgroundColor: isInteractive ? "#007DC1" : undefined,
                borderRadius: 5,
                barThickness: 20,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: "x",
            onClick: (event, elements) => {
              if (isInteractive && elements.length > 0) {
                const index = elements[0].index;
                handleBarClick(index);
              }
            },
            plugins: {
              legend: {
                display: false,
              },
              datalabels: {
                align: "end",
                anchor: "end",
                formatter: (value) => {
                  return value > 0 ? `${value}%` : "";
                },
                color: (context) => {
                  const dataIndex = context.dataIndex;
                  return sourceData[dataIndex].color;
                },
                font: {
                  size: 14,
                  weight: "bold",
                  family: "Lato, sans-serif",
                },
              },
            },
            scales: {
              x: {
                beginAtZero: true,
                max: total,
                ticks: {
                  stepSize: 20,
                  color: "#003C5D",
                  font: {
                    size: 12,
                    family: "Lato, sans-serif",
                  },
                },
                grid: {
                  color: "#DDE3EE",
                  borderDash: [5, 5],
                },
              },
              y: {
                ticks: {
                  padding: 20,
                  color: "#003C5D",
                  font: {
                    size: 12,
                    family: "Lato, sans-serif",
                  },
                },
                grid: {
                  display: false,
                },
              },
            },
            layout: {
              padding: {
                bottom: 20,
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default BarChart;
